module.exports = __webpack_public_path__ + "static/media/Panel-Employees-Card.ca04f709.svg";